define('views/PressView',[
    'backbone',
    'lodash',
    'text!templates/press.html',
    'app'
], function (Backbone, _, pressTmpl, App) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        template: _.template(pressTmpl),

        render: function () {
            this.$el.html(this.template(App));
        }

    });

});
